<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
                    <c-form-item type="input" label="礼品卡任务：" name="task_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="礼品卡号：" name="card_no" placeholder="请输入礼品卡号"></c-form-item>
                    <c-form-item type="input" label="礼品卡编码：" name="card_code" placeholder="请输入礼品卡编码"></c-form-item>
                    <c-form-item type="input" label="领取人：" name="receive_member_user" placeholder="领取人昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="代理：" name="agent_member_user" placeholder="代理昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="商品名称：" name="product_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="商品规格：" name="product_sku_spec" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="SKU编码：" name="product_sku_code" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="checkbox" name="card_state" :options="cardState"></c-form-item>
				</c-form>
			</m-search>
            <m-operate v-if="auth('b_gift_card_voiding')">
                <c-button color="black" power="b_gift_card_voiding" @click="voidingGiftCard">作废</c-button>
            </m-operate>
			<c-table ref="table">
                <c-table-column
                        type="selector"
                ></c-table-column>
				<c-table-column
					label="卡片状态"
					name="card_state"
                    width="80"
				>
					<template v-slot="{data}">
                        <span v-if="data.card_state == 0" style="color:blue">待领取</span>
                        <span v-if="data.card_state == 1" style="color:green">已领取</span>
                        <span v-if="data.card_state == 2" style="color:#999">已失效</span>
                        <span v-if="data.card_state == 3" style="color:red">已作废</span>
					</template>
				</c-table-column>
                <c-table-column
                        label="礼品卡号"
                        name="card_no"
                        width="100"
                ></c-table-column>

				<c-table-column
					label="礼品卡编码"
					name="card_code"
					width="100"
				></c-table-column>

                <c-table-column
                        label="二维码"
                        name="qr_code_image"
                        width="60"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.qr_code_image" preview size="40" style="margin-right: 10px;"></c-image>
                    </template>
                </c-table-column>

                <c-table-column
                        label="任务"
                        name="task_name"
                        width="140"
                ></c-table-column>
                <c-table-column
                        label="代理头像/昵称/等级"
                        name="agent_member_user"
                        width="140"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross" v-if="data.agent_member_user">
                            <c-image :src="data.agent_head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.agent_nick_name||data.agent_mobilephone}}</span><br>
                                <span style="color:blue">{{data.agent_level_name}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="商品"
                        name="product_sku"
                        width="320"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>
                <c-table-column
                        label="规格"
                        name="product_sku_spec"
                        width="140"
                >
                </c-table-column>
                <c-table-column
                        label="sku编码"
                        name="product_sku_code"
                        width="120"
                >
                </c-table-column>

                <c-table-column
                        label="卡有效期"
                        name="card_valid_date"
                        width="280"
                >
                    <template v-slot="{data}">
                        {{data.valid_date_start}} - {{data.valid_date_end}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="create_user"
                ></c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="领取人"
                        name="receive_member_user"
                        width="140"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross" v-if="data.receive_member_user">
                            <c-image :src="data.receive_head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.receive_nick_name||data.receive_mobilephone}}</span><br>
                                <span style="color:blue">{{data.receive_level_name}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="领取时间"
                        name="reveive_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="作废人"
                        name="voiding_user_name"
                ></c-table-column>
                <c-table-column
                        label="作废时间"
                        name="voiding_date"
                        width="140"
                ></c-table-column>
                <c-table-column
                        label="作废原因"
                        name="voiding_remark"
                        width="140"
                ></c-table-column>
			</c-table>
		</module>
        <c-dialog ref="voidingDialog" title="请确认" width="600" @resolve="submitVoidingData">
            <c-form ref="voidingForm">
                <c-form-item type="textarea" label="作废原因" name="voiding_remark" v-model="voiding_remark"></c-form-item>
            </c-form>
        </c-dialog>
	</page>

</template>

<script>
import {mapGetters, mapState} from 'vuex'
    import productInfo from "@/components/public/product_info.vue";
	
	export default {
		name: 'm_gift_card_list',
        components: {productInfo},

        props: {
            task_name: String
        },

		data() {
			return {
                cardState: [{
					name: '待领取',
					value: 0
				}, {
					name: '已领取',
					value: 1
				}, {
					name: '已失效',
					value: 2
				},{
                    name: '已作废',
                    value: 3
                }],
                // 作废原因
                voiding_remark: ''
			}
		},

        watch: {
            defaultSearch(val) {
                // 返回空对象而不是 undefined
                return {};
            }
        },
		
		computed: {
			...mapState(['dict']),
            ...mapGetters({
                auth: 'power'
            }),
            defaultSearch(val) {
                return {};
            }
		},
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/giftCard/list',
					data
				});
			},
            voidingGiftCard(){
                // 获取符合自定义条件的行数据
                var selected = this.$refs.table.getRow('selected');
                selected = selected.filter(item => item.data.card_state == 0);
                if (selected == null || selected.length < 1) {
                    this.$message({
                        text: '请选择需要作废且为待领取的卡'
                    });
                    return  ;
                }
                this.voiding_remark = '';
                this.$refs.voidingDialog.open();
            },
            submitVoidingData(){
                var selected = this.$refs.table.getRow('selected');
                this.request({
                    url: '/giftCard/voiding',
                    data: {
                        card_list: selected.map(item => ({ id: item.data.id })),
                        voiding_remark: this.voiding_remark
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '作废成功'
                        });
                        this.$refs.table.update();
                    },
                    error: () => {
                        this.$message({
                            text: '作废失败'
                        });
                    },
                    finally: () => {
                        this.$refs.voidingDialog.close();
                    }
                });
            },
		}
	}
</script>